import store from "../store";
import jwt from "jsonwebtoken";
import {getAccessToken} from "../utils/auth-requests";

//HTTP() sets the Authorization header from localStorage before getAccessToken() gets the chance to
//refresh it, so a request could still go out with the token that just expired
function isExpiredBearer(authorization) {
    if(typeof authorization !== 'string' || authorization.indexOf('Bearer ') !== 0) {
        return false;
    }
    let payload = jwt.decode(authorization.substring(7));
    return !!(payload && payload.exp && payload.exp * 1000 < Date.now());
}

export async function interceptEBORequest(url, config) {
    let accessToken = store.getters.accessToken;
    if(accessToken == null || url === process.env.VUE_APP_BASE_URL+"/refresh-token") {
        return [url, config]
    }
    accessToken = await getAccessToken(store);
    if(accessToken === false || accessToken === null || typeof accessToken === 'undefined') {
        return [url, config]
    } else {
        //Sets the access token
        if(config.headers.Authorization === null || typeof config.headers.Authorization === 'undefined')
        {
            config.headers = {
                Authorization: "Bearer " + accessToken
            };
        }
        else if(isExpiredBearer(config.headers.Authorization))
        {
            config.headers.Authorization = "Bearer " + accessToken;
        }
        return [url, config];
    }
}
